import StringUtil from '../../utils/StringUtil';

export default class FormItemStringResolver
{
	static RESOLVER_FALSE_TAG = "fase!@#)l:";

	static getResult()
	{
		var input = arguments[0];
		//0-->Trim
		var _trim = arguments[1];
		/*//1-->Intercept
		var _intercept:String = agrs[1] as String;*/
		//2-->ChangeCase
		var _changeCase = arguments[2];
		//3 --> StringSize
		var _stringSize = arguments[3];
		//4 --> Reg
		var regPro = arguments[4];
		//5 --> notNull
		var _notNull = arguments[5];
		
		var result = FormItemStringResolver.trim(_trim,input);
		
		
		result = FormItemStringResolver.changeCase(_changeCase,result);
		
		if(_notNull == true && (result == "" || result == null))
			return FormItemStringResolver.RESOLVER_FALSE_TAG + "不允许空值";
		
		
		if(regPro.indexOf("##")!=-1)
		{
			var a = regPro.split("##");
			var regResult = a[0];
			var regStr = a[1];
		}
		else
		{
			regResult = result + "不符合正则表达式:" + regPro;
			regStr = regPro;
		}
		
		if(regStr != null && regStr != "")
		{	
			var partten = new RegExp(regStr)
				//"^((([1-9]\\d*\\.?\\d*)|(0\\.\\d*[1-9]))\\*?[1-9]\\d*((,?)|(\\+?)))*");
			var partternArr = partten.exec(result);
			//if(partten.exec(result) == null)
			//if(result.search(partten) == -1)
			//alert(JSON.stringify(partternArr));
			if(partternArr == null)
			{
				return FormItemStringResolver.RESOLVER_FALSE_TAG + regResult;	
			}
			else
			{
				if(partternArr[0] != result)
					return FormItemStringResolver.RESOLVER_FALSE_TAG + regResult;
			}
			
		}
		
		return result;
	}
	
	static changeCase(type,input)
	{
		switch(type)
		{
			case "None":
				return input;
			case "Lower":
				return input.toLowerCase();
			case "Upper":
				return input.toUpperCase();
			default:
				return input;
		}
	}
	
	static trim(type,input)
	{
		switch(type)
		{
			case "None":
				return input;
			case "Left":
				return StringUtil.trimLeft(input);
			case "Right":
				return StringUtil.trimRight(input);
			case "LeftRight":
				return StringUtil.trimLeftRight(input);
			case "Through":
				return StringUtil.trimThrough(input," ");
			default:
				return input;
		}  
	}
}





// WEBPACK FOOTER //
// ./src/formItem/resolver/FormItemStringResolver.js